import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from '@app/shared';
import { SharedSignupModule } from '@app/shared-signup/shared-signup.module';
import { CartState } from '@app/store/state/cart.state';
import { ButtonLoaderModule, IkCardSelectableIconItemModule, ValidationCheckModule } from '@infomaniak/angular-common';
import { HeaderTitleModule } from '@infomaniak/ngx-header-title';
import { IkCardSelectableModule } from '@infomaniak/ngx-card-selectable';
import { TranslocoModule } from '@ngneat/transloco';
import { NgxsModule } from '@ngxs/store';
import { HeaderInvitationB2bPartnershipLogosModule } from '../invitation-b2b-shared/header-partnership-logos/header-invitation-b2b-partnership-logos.module';
import { InvitationB2BInvitationAcceptedModule } from '../invitation-b2b-shared/invitation-accepted/invitation-b2b-accepted.module';
import { InvitationB2BInvitationRejectedModule } from '../invitation-b2b-shared/invitation-rejected/invitation-b2b-rejected.module';
import { InvitationB2BPageWrapperModule } from '../invitation-b2b-shared/page-wrapper/invitation-b2b-page-wrapper.module';
import { InvitationB2BResendSuccessModule } from '../invitation-b2b-shared/resend-success/invitation-b2b-resend-success.module';
import { InvitationB2bAccessListDisplayProductsComponent } from './components/access-list/display-products/invitation-b2b-access-list-display-products.component';
import { InvitationB2bAccessListComponent } from './components/access-list/invitation-b2b-access-list.component';
import { InvitationB2BPartnerAlreadyCheckedComponent } from './components/already-checked/invitation-b2b-partner-already-checked.component';
import { InvitationB2bOnlyForOwnersComponent } from './components/only-for-owners/invitation-b2b-only-for-owners.component';
import { InvitationB2bWrongAccountComponent } from './components/wrong-account/invitation-b2b-wrong-account.component';
import { InvitationB2BPartnerComponent } from './invitation-b2b-partner.component';


@NgModule({
  declarations: [
    InvitationB2BPartnerComponent,
    InvitationB2bWrongAccountComponent,
    InvitationB2bAccessListComponent,
    InvitationB2BPartnerAlreadyCheckedComponent,
    InvitationB2bAccessListDisplayProductsComponent,
    InvitationB2bOnlyForOwnersComponent,
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    NgxsModule.forFeature([CartState]),
    SharedModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    ValidationCheckModule,
    MatButtonModule,
    SharedSignupModule,
    HeaderTitleModule,
    ButtonLoaderModule,
    IkCardSelectableModule,
    IkCardSelectableIconItemModule,
    MatDialogModule,
    InvitationB2BPageWrapperModule,
    HeaderInvitationB2bPartnershipLogosModule,
    InvitationB2BResendSuccessModule,
    InvitationB2BInvitationAcceptedModule,
    InvitationB2BInvitationRejectedModule,
  ],
  exports: [InvitationB2BPartnerComponent]
})
export class InvitationB2BPartnerModule {
}
